<script>
export default {
  name: "DidoMillesimeApiDoc",
};
</script>

<script setup>
import { ref, watch } from "vue";
import "rapidoc";
import api from "../../../api";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  rid: { type: String, required: true },
  millesime: { type: String, required: true },
});

// define watchers
watch(
  () => [props.apiUrl, props.rid, props.millesime],
  () => refreshUrl(),
);

// define reactive data for rapidoc dom node
const apidoc = ref(null);

// define methods
const refreshUrl = async () => {
  await fetch(api.urlMillesimeSwagger(props.apiUrl, props.rid, props.millesime))
    .then((response) => response.json())
    .then((json) => {
      json.tags = json.tags.map(({ name, description }) => ({
        name,
        description,
        "x-tag-expanded": false,
      }));
      return json;
    })
    .then((spec) => apidoc.value.loadSpec(spec));
};

// init
refreshUrl();
</script>

<template>
  <div class="q-pa-xl fit">
    <rapi-doc
      ref="apidoc"
      update-route="false"
      primary-color="#7fc6a4"
      layout="row"
      render-style="view"
      schema-style="tree"
      default-schema-tab="model"
      show-info="false"
      show-header="false"
      allow-server-selection="false"
      allow-authentication="false"
      allow-search="true"
      allow-advanced-search="true"
      allow-try="true"
      schema-description-expanded="true"
      allow-schema-description-expand-toggle="true"
      use-path-in-nav-bar="true"
      regular-font="Marianne"
    />
  </div>
</template>
